<ng-container *ngIf="unreadCount$ | async as unreadCount; else notUnreadCountIcon">
  <i
    class="pi pi-bell p-text-secondary cursor-pointer hover:frm-color-blue"
    pBadge
    style="font-size: 2.2rem"
    [value]="unreadCount?.toString()"
    severity="danger"
    (click)="showChangeValue()"></i>
</ng-container>

<ng-template #notUnreadCountIcon>
  <i
    class="pi pi-bell p-text-secondary cursor-pointer hover:frm-color-blue"
    style="font-size: 2.2rem"
    (click)="showChangeValue()"></i>
</ng-template>
